( function ( $ ) {    

    // Show items list
    $('.filter-search-input').find('input').on( 'click' , function() {
        $('.filter-search-input').find('.filter-search-list').show()
    })

    // Close items list when click outside
    $(document).click(function(event) {
        let positionEl = $('.filter-search-input.position')[0]
        let locationEl = $('.filter-search-input.location')[0]

        if (!$(event.target).closest(positionEl).length) {
            $(positionEl).find('.filter-search-list').hide()
        }
        
        if (!$(event.target).closest(locationEl).length) {
            $(locationEl).find('.filter-search-list').hide()
        }
    });

    $('.remove-search-value').on('click', function() {
        $(this).closest('.filter-search-input').find('.filter-search-input-field').val('').attr('data-id', '');
        filterInputItems(true)       
    });

    // Insert selected data to input 
    $('.filter-search-list p').on( 'click' , function() {
        getData($(this))
    })

    filterInputItems()

    // Filter items in filter list based on input value 
    function filterInputItems(clear = false) {

        let input = $('.filter-search-input').find('input')
        
        input.each( function() {
            let inputValue = $(this).length ? $(this).val().toLowerCase() : '';
            list = $(this).siblings('.filter-search-list')

            if (clear) {
                list.find('.filter-search-list-item').each(function() {
                   $(this).show();
                });        
            }
            filterList( list, '.filter-search-list-item', inputValue ) 

            $(this).on('input', function() {
                let inputValueI = $(this).val().toLowerCase();
                let listI = $(this).siblings('.filter-search-list')
                filterList( listI, '.filter-search-list-item', inputValueI )     
            })
        })
        
    }
    
    function getData(ptag) {
        let position = $('.filter-search-input.position input');
        let location = $('.filter-search-input.location input');

        let elementsArr = [ position, location ]
        clearData(elementsArr)

        let paragraph = ptag
        let id = paragraph.attr('data-id')
        let textValue = paragraph.text()

        if ( typeof id !== 'undefined' && id !== null && id.toString().trim() !== '' ) {
            paragraph.closest('.filter-search-input').find('input').attr('data-id', id);            
        } 
        
        paragraph.closest('.filter-search-input').find('input').val(textValue)         

        let positionId = position.attr('data-id');        
        let locationId = location.attr('data-id');            
        
        paragraph.closest('.filter-search-input').find('.filter-search-list').hide()

        $('#job-table').find('.job-result').each(function() {
            if ( $(this).attr('data-id') !== positionId ) {
                $(this).hide()
            } ;
        });        
    }

    function clearData(arr) {
        arr.map( item => {
            if(!item.val()) {
                item.attr('data-id', '')
            }
        })
    }
    
    function filterList(list, itemClass, inputValue) {
        list.find(itemClass).each(function() {
            var itemText = $(this).text().toLowerCase();         

            if (itemText.includes(inputValue)) {
                $(this).show(); // Show item if it matches the input
            } else {
                $(this).hide(); // Hide item if it doesn't match the input
            }
        }); 
    }

} )( jQuery );